import { useBahasa } from '../../../app/i18n'
import { istilah } from '../../../shared/lib/istilah'
import { sejak } from '../../../shared/lib/waktu'
import { useKesehatan } from '../../../domains/tenancy/api'
import {
  Baris, Chip, Gagal, KepalaHalaman, Kosong, Memuat, Panel, Tabel,
} from '../../../shared/ui'

/**
 * Menu kelima, dan yang terakhir hidup — ia ditampilkan MATI sejak fase B.
 *
 * TIDAK ADA lampu "semua hijau". Tiap baris menyebut APA yang diperiksa dan APA
 * jawabannya, karena layar kesehatan yang cuma bisa berkata "ok" tidak bisa
 * membedakan sehat dari belum diperiksa.
 *
 * Keterangan tiap pemeriksaan ikut ditampilkan, bukan disembunyikan di tooltip:
 * yang membuka layar ini sedang mencari sebab, dan angka tanpa arti menambah
 * pertanyaan alih-alih menjawabnya.
 */
export default function Sistem() {
  const { t, locale } = useBahasa()
  const q = useKesehatan()

  if (q.isLoading) return <Memuat tinggi={6} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />

  const d = q.data

  return (
    <>
      <KepalaHalaman judul={t('sis.judul')} keterangan={t('sis.keterangan')} />

      <Panel judul={t('sis.periksaJudul')} catatan={t('sis.periksaCatatan')}>
        <Tabel kepala={[t('sis.kolPeriksa'), t('sis.kolNilai'), t('sis.kolArti')]}>
          {(d?.periksa ?? []).map((p) => (
            <Baris key={p.nama}>
              <td className="font-semibold">
                <span className="flex items-center gap-2">
                  <Chip nada={p.nada} titik>{''}</Chip>
                  {p.nama}
                </span>
              </td>
              <td className="font-mono text-[11.5px] text-ink2">{p.nilai}</td>
              <td className="text-[11.5px] text-ink2 max-w-[52ch]">{p.keterangan}</td>
            </Baris>
          ))}
        </Tabel>
      </Panel>

      <Panel judul={t('sis.operatorJudul')} catatan={t('sis.operatorCatatan')}>
        {(d?.operator ?? []).length === 0 ? (
          <Kosong judul={t('sis.operatorKosong')} />
        ) : (
          <Tabel kepala={[t('sis.kolNama'), t('sis.kolPeran'), t('sis.kolMasukTerakhir'),
                          t('sis.kolKeadaan')]}>
            {d.operator.map((u) => (
              <Baris key={u.id}>
                <td className={u.is_active ? 'font-semibold' : 'font-semibold text-ink3'}>
                  {u.username}
                </td>
                {/* Peran DISEBUT, bukan diandaikan. Daftar ini menampilkan akun yang
                    melihat SEMUA tenant; baris berperan lain di sini adalah temuan, dan
                    tanpa kolomnya temuan itu tidak pernah terlihat. */}
                <td className="text-ink2">{istilah(t, 'peran', u.role)}</td>
                {/* Akun operator yang tidak pernah dipakai adalah kunci yang menganggur.
                    "belum pernah" berbeda dari "lama tidak masuk". */}
                <td className="text-[11.5px] text-ink2">
                  {u.last_login_at
                    ? sejak(u.last_login_at, locale)
                    : <span className="text-ink3">{t('sis.belumPernahMasuk')}</span>}
                </td>
                <td>
                  <Chip nada={u.is_active ? 'ok' : 'idle'}>
                    {u.is_active ? t('adm.aktif') : t('adm.nonaktif')}
                  </Chip>
                </td>
              </Baris>
            ))}
          </Tabel>
        )}
      </Panel>
    </>
  )
}
